import { useSelector } from "react-redux";

export const useCitra = () => {
  const { desa } = useSelector((state) => state.Auth);

  if (desa) {
    const { nama_desa, kecamatan } = desa;

    if (kecamatan) {
      return `${
        process.env.REACT_APP_CITRA_URL
      }/citra${nama_desa.toLowerCase()}${kecamatan?.nama_kecamatan?.toLowerCase()}/{z}/{x}/{y}.png`;
    }
  }

  return `${process.env.REACT_APP_CITRA_URL}/citrapundungan/{z}/{x}/{y}.png`;
};
